<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        console.log('payload', payload.order);
    },
    methods:{
       filter: function(){
            let state = this;
            state.items = [];
            $('#spinner').modal('toggle');
            
            //if(this.filters.cnpj)
            let filters = JSON.parse(JSON.stringify(this.filters))
                filters.cnpj = this.filters.cnpj.replace(/\D/g,'')
            
            setTimeout(() => {
                Request.do(state, 'POST', Request.getDefaultHeader(state), filters, `${Endpoints.companies.filter}`,
                    (response)=>{//SUCCESS CALLBACK
                        console.log('RESULT', response)
                        state.items = response.results[0].paginatedResults;
                        $('#spinner').modal('toggle');
                    },
                    (error)=>{//ERROR CALLBACK
                        console.log(error);
                    }
                );
            }, 500)
           
        },
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;
        },
        getResultValue(result) {
            return `${result.fantasyName || ''} ${result.socialName} ${result.document}`;
        },
        submitFilter: function(term) {

            if(!term) return;

            this.filters.name = `${term.fantasyName}|${term.socialName}|${term.document}`;            
            this.filter();
            
        },
        onChangeName: function(input) {
            let state = this;            
            
            this.filters.name = input;
            if(input.length < 4) return [];
            
            return new Promise(
                (resolve, reject) => {
                    
                    Request.do(state, 'GET', Request.getDefaultHeader(state), { }, `${Endpoints.companies.suggest}?term=${input}`,
                        (response)=>{
                            console.log(response);
                            resolve(response);
                        },
                        (error)=>{//ERROR CALLBACK
                            console.log(error);
                            reject(error);
                        }
                    );

                }
            )     

        },
        selectItem: function(item){

           $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            console.log('selectItem ORDER', this.order)
            this.data._id = this.order._id;
            this.data.company = item._id;

            Request.do(this, 'PUT', Request.getDefaultHeader(this), this.data,  `${Endpoints.orders.holder.addCompany}`,
                (companyResponse)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    //$('#modalAddCompanyPart').modal('toggle');
                    this.$emit('confirmation-return', 1);
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        this.$emit('confirmation-return', 2);
                    }
                    
            });
         
        },
        checkClose: function(item){
       
        },
        confirmArchive: function(item){
            this.titleToast = this.$t("string.msg.confirm");
            this.messageToast = this.$t("response.close.order.confirmation");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            this.orderSelected = item;

             setTimeout(async function(){
                this.$('#confirmationCloseCertifie').modal('show');
                }, 100);
        },
        archive: function(response, justifyClose){
       
 
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
